import { Site } from '@envato/foundation-types'
import * as React from 'react'

import HoverFocusObserver from '../hoverFocusObserver'
import AudioJungleItemCard from './audioJungleItemCard'
import CodeCanyonItemCard from './codeCanyonItemCard'
import GraphicRiverItemCard from './graphicRiverItemCard'
import PhotoduneGridItemCard from './photoduneGridItemCard/photoduneItemCardContainer'
import ThemeForestItemCard from './themeForestItemCard'
import VideoHiveItemCard from './videoHiveItemCard/videoHiveItemCardContainer'

import { IProps } from './itemCardContainer'

const ItemCardContent = ({ currentSite, ...props }: IProps): any => {
  if (currentSite === Site.photodune) {
    return <PhotoduneGridItemCard {...props} />
  } else if (currentSite === Site.graphicriver) {
    return <GraphicRiverItemCard {...props} />
  } else if (currentSite === Site.threedocean) {
    return <GraphicRiverItemCard {...props} />
  } else if (currentSite === Site.audiojungle) {
    return <AudioJungleItemCard {...props} />
  } else if (currentSite === Site.videohive) {
    return <VideoHiveItemCard {...props} />
  } else if (currentSite === Site.codecanyon) {
    return <CodeCanyonItemCard {...props} />
  } else {
    return <ThemeForestItemCard {...props} />
  }
}

const ItemCard = (props: IProps): any => {
  return (
    <HoverFocusObserver>
      {({ isHovered, isFocused }) => (
        <ItemCardContent
          isCardHovered={isHovered}
          isCardFocused={isFocused}
          {...props}
        />
      )}
    </HoverFocusObserver>
  )
}

export default ItemCard
